import { Tab } from "@headlessui/react";
import dayjs from "dayjs";
import TabContent from "./TabContent";

const FormsTabs = ({ startDate, endDate, answers }: any) => {

  const filteredFormData = answers?.filter((form: any) => {
    const start = dayjs(startDate).startOf('day');
    const end = dayjs(endDate).endOf('day');
    const date = dayjs(form?.date);
    return date.isAfter(start) && date.isBefore(end);
  });

  return (
    <>
      {filteredFormData?.length === 0 ? (
        <div className="bg-[#fff] px-5 py-10 rounded-lg mt-[5rem]">
          <p className="text-5xl text-center text-primary_blue">No Check-In Form History Found</p>
        </div>
      ) : (
        <Tab.Group>
          <div className="sm:flex sm:flex-row flex-col mb-12 sm:items-start">
            <Tab.List className="min-w-[158px] flex flex-row pb-8 overflow-x-auto sm:overflow-visible sm:flex-col sm:border-b-0  sm:border-l-2 sm:border-[#373737] tabs_blk self-start">
              {filteredFormData?.map((item: any, index: number) => {
                return (
                  <Tab key={index} className={({ selected }) => (
                    selected ? "text-[#299aff] text-4xl  sm:mb-[3rem] font-bold pb-[1rem] tablet:pb-0  form_dot border-b-2 border-[#ffffff] sm:border-b-0 active focus:outline-none" :
                      "form_dot sm:pl-4 sm:p-0 border-b-2 border-[#299aff] text-[#373737] px-8 pb-[1rem] tablet:pb-0 text-4xl sm:border-b-0  sm:mb-[3rem] focus:outline-none"
                  )
                  }>
                    <p className="mb-2">{dayjs(item?.date).format("MM/DD/YYYY")}</p>
                    <p>{dayjs(item?.date).format("hh:mm A")}</p>
                  </Tab>
                )
              })}
            </Tab.List>
            <Tab.Panels className="inline-block bg-[#ffffff] mt-[3.5rem] sm:mt-0 w-full  border-2 border-[#288EBF]">
              {filteredFormData?.map((item: any, index: number) => {
                return (
                  <Tab.Panel key={index}>
                    <TabContent
                      answers={filteredFormData}
                      content={item?.data} />
                  </Tab.Panel>
                )
              })}
            </Tab.Panels>
          </div>
        </Tab.Group>
      )}
    </>
  );
};
export default FormsTabs;
